import React from 'react';
import { Col, Container, Row } from 'reactstrap';

const Footer = () => {

    const isPaginaMapas = location.pathname === "/vendas";

    return (
        <React.Fragment>
            <footer className={isPaginaMapas ? "footer footer-mapas" : "footer"}>
                <Container fluid>
                    <Row>
                        <Col sm={6}>
                            {new Date().getFullYear()} © EVOMAP 1.5.0
                        </Col>
                        <Col sm={6}>
                            <div className="text-sm-end d-none d-sm-block">
                                Desenvolvido por JPX
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </React.Fragment>
    );
};

export default Footer;